module.exports = __webpack_public_path__ + "static/children-course-image-a336e0b80935cc6ef51afe0fa715146e.jpg";